export default state => state;